module.exports = __webpack_public_path__ + "static/media/GRT-ETH.b8c587fe.png";